import { render, staticRenderFns } from "./ku-main-layout.vue?vue&type=template&id=2b214f5b&scoped=true"
import script from "./ku-main-layout.vue?vue&type=script&lang=js"
export * from "./ku-main-layout.vue?vue&type=script&lang=js"
import style0 from "./ku-main-layout.vue?vue&type=style&index=0&id=2b214f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b214f5b",
  null
  
)

export default component.exports